import Grid from '@mui/material/Grid';
import ListItem from '@mui/material/ListItem';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import packageJson from '../../../package.json';
import { IcoBalance } from '../common/svg';
import { getLandingState, getMainUserState } from '../main/selector';

import { BalanceContext } from '@/contexts/BalanceContext';
import { RwdSvgIcon } from '../rwdGame/components/RwdSvgIcon/RwdSvgIcon';
import { RwdTypography } from '../rwdGame/components/RwdTypography';
import './index.scss';

type UserInformationProps = {
    isHeader: boolean;
};
type InfoData = {
    justifyContent: string;
    alignItems: string;
    alignItemsBalance: string;
    spacing: number;
    showUserName: string;
    lastLogin: string;
    showPromotion: boolean;
};
const initData: InfoData = {
    justifyContent: '',
    alignItems: '',
    alignItemsBalance: '',
    spacing: 1,
    showUserName: '',
    lastLogin: '',
    showPromotion: false,
};
export const UserInformation = (props: UserInformationProps) => {
    const { isHeader } = props;
    const { t } = useTranslation();
    const [data, setData] = useState<InfoData>(initData);
    const { Username, LastLogin } = useSelector(getMainUserState);
    const { username: paramUserName } = useSelector(getLandingState);
    const { displayBalance, currency } = useContext(BalanceContext);

    useEffect(() => {
        if (Username) {
            const newData = {} as InfoData;
            if (isHeader) {
                newData.justifyContent = 'flex-end';
                newData.alignItems = 'flex-end';
                newData.alignItemsBalance = 'stretch';
                newData.spacing = 0;
            }
            newData.showUserName = paramUserName ? paramUserName : Username;
            newData.lastLogin = LastLogin ? LastLogin : '';
            setData(newData);
        }
    }, []);

    return (
        <ListItem disablePadding className="user-info-list">
            <Grid
                container
                display={'flex'}
                direction="column"
                justifyContent={data.justifyContent}
                alignItems={data.alignItems}
                spacing={data.spacing}
                className="user-info-list-container"
            >
                {/* {isHeader && (
                    <Grid item className="eventInfo">
                        {data.showPromotion && <PromotionIndicator />}
                    </Grid>
                )} */}
                {!isHeader && (
                    <Grid item display={'flex'}>
                        <RwdTypography
                            stepIndex={2}
                            landscapeStepIndex={3}
                            lineHeight={1}
                        >
                            {data.showUserName}
                        </RwdTypography>
                    </Grid>
                )}
                <Grid item className="balance-info">
                    <Grid item display={'flex'}>
                        <RwdSvgIcon
                            portraitIconSize={18.7}
                            landscapeIconSize={34}
                        >
                            <IcoBalance width={'100%'} height={'100%'} />
                        </RwdSvgIcon>
                    </Grid>
                    <Grid
                        item
                        display={'flex'}
                        gap={'0.15rem'}
                        alignItems={'baseline'}
                    >
                        <Grid item>
                            <RwdTypography
                                stepIndex={2}
                                landscapeStepIndex={3}
                                lineHeight={1}
                            >
                                {displayBalance} {currency}
                            </RwdTypography>
                        </Grid>
                    </Grid>
                </Grid>
                {!isHeader && (
                    <>
                        <Grid
                            container
                            direction="row"
                            className="last-login-info my-font-10"
                        >
                            <Grid item>
                                {data.lastLogin != '' ? (
                                    <RwdTypography
                                        stepIndex={0}
                                        landscapeStepIndex={2}
                                    >
                                        {t('last_login')} {data.lastLogin}
                                    </RwdTypography>
                                ) : (
                                    <></>
                                )}
                            </Grid>
                            <Grid item>
                                <RwdTypography
                                    stepIndex={0}
                                    landscapeStepIndex={2}
                                    lineHeight={1}
                                >
                                    {`v${packageJson.version}`}
                                </RwdTypography>
                            </Grid>
                        </Grid>
                    </>
                )}
            </Grid>
        </ListItem>
    );
};
